import axios from '../../config/axios';


  const apiAuthen = async (data) => {

    try {
      const result = await axios.post(`/customer/login`, data
      )
      return result
    } catch (error) {
      return error && error.response && error.response.data
    }
  }


  export {
    apiAuthen
}